"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EyeType;
(function (EyeType) {
    EyeType["Default"] = "Default";
    EyeType["Happy"] = "Happy";
    EyeType["Close"] = "Close";
    EyeType["Surprised"] = "Surprised";
    EyeType["Side"] = "Side";
    EyeType["Wink"] = "Wink";
    EyeType["WinkWacky"] = "WinkWacky";
    EyeType["Cry"] = "Cry";
    EyeType["EyeRoll"] = "EyeRoll";
    EyeType["Squint"] = "Squint";
    EyeType["Hearts"] = "Hearts";
    EyeType["Dizzy"] = "Dizzy";
})(EyeType || (EyeType = {}));
exports.default = EyeType;
